import keycloakService from '@/services/keycloakService';
import store from '@/store';
import { createRouter, createWebHistory } from 'vue-router';

const mapPage = () => import('@/components/modules/mapPage.vue');
const analyticsPage = () => import('@/components/modules/analyticsPage.vue');
const manageUsers = () => import('@/components/modules/user/manageUsers.vue');
const userProfile = () => import('@/components/modules/user/userProfile.vue');
const login = () => import('@/components/modules/user/login.vue');
const register = () => import('@/components/modules/user/register.vue');
const compareMaps = () => import('@/components/modules/airmap/compareMaps/compareMaps.vue');
const accountRecovery = () => import('@/components/modules/user/accountRecovery.vue');
const recovery = () => import('@/components/modules/user/recovery.vue');
const notFound = () => import('@/components/shared/notFound.vue');
const allProjects = () => import('@/components/modules/home/allProjects.vue');
const createProject = () => import('@/components/modules/home/createProject.vue');

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/' : '/'),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: allProjects,
      meta: { showSidebar: true },
    },
    {
      path: '/all-projects',
      name: 'all-projects',
      component: allProjects,
      meta: { showSidebar: true },
    },
    {
      path: '/create-project',
      name: 'create-project',
      component: createProject,
      meta: { showSidebar: true },
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: analyticsPage,
      meta: { showSidebar: true },
    },
    {
      path: '/user-profile',
      name: 'user-profile',
      component: userProfile,
      meta: { showSidebar: true },
    },
    {
      path: '/manage-users',
      name: 'manage-users',
      component: manageUsers,
      meta: { showSidebar: true },
    },
    {
      path: '/map/:projectId',
      name: 'map',
      component: mapPage,
      beforeEnter: (to, from, next) => {
        const projectId = to.params.projectId;
        if (projectId) {
          store
            .dispatch('homeStore/getProjectById', {
              projectId,
              page: 'map',
            })
            .then(() => next())
            .catch(() => next('/home'));
        } else {
          next('/home');
        }
      },
    },
    {
      path: '/compare',
      name: 'compare',
      component: compareMaps,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/recovery',
      name: 'accountRecovery',
      component: accountRecovery,
      meta: {
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    {
      path: '/recovery/:uid/:token',
      name: 'recovery',
      component: recovery,
      props: true,
      meta: {
        public: true,
        onlyWhenLoggedOut: true,
      },
    },
    { path: '/:pathMatch(.*)*', component: notFound },
  ],
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);

  const loggedIn = keycloakService.isLoggedIn();
  if (!isPublic && !loggedIn) return next({ path: '/login' });

  if (loggedIn && onlyWhenLoggedOut) return next('/');
  next();
});

router.afterEach(to => {
  if (to.hash) {
    router.replace({ path: to.path, query: to.query, hash: '' });
  }
});
export default router;
